import { ContractChangeValidationListFragment, EmployeeLevelEnum } from '../../../../types'
import { getUndefinedContractChangeValuesForGivenMonth } from './validationHelpers'

export type EmployeeLevelChangeValidationType = {
  valid: boolean
  minimalValidValue?: EmployeeLevelEnum
}

export const employeeLevelChangeValidation = (
  date: Date,
  employeeLevel: EmployeeLevelEnum,
  contractChangeValidationList: ContractChangeValidationListFragment,
  employeeLevels: EmployeeLevelEnum[],
): EmployeeLevelChangeValidationType => {
  const minimalValidValue: EmployeeLevelEnum = getUndefinedContractChangeValuesForGivenMonth(date, contractChangeValidationList)
    .employeeLevel
  if (employeeLevels.indexOf(employeeLevel) <= employeeLevels.indexOf(minimalValidValue)) {
    return {
      valid: false,
      minimalValidValue: minimalValidValue,
    }
  }

  return { valid: true }
}
